exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.wrapper-btns[data-v-2d89d280]{display:-webkit-box;display:-ms-flexbox;display:flex\n}\n", "", {"version":3,"sources":["/home/jenkins/agent/workspace/asiapay-system-manager-merchant/src/components/cuscom/btns-group.vue"],"names":[],"mappings":";AACA,+BAA+B,oBAAoB,oBAAoB,YAAY;CAClF","file":"btns-group.vue","sourcesContent":["\n.wrapper-btns[data-v-2d89d280]{display:-webkit-box;display:-ms-flexbox;display:flex\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2d89d280","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/cuscom/btns-group.vue
// module id = GrzU
// module chunks = 2